module.exports = __webpack_public_path__ + "static/duodrone-c17b7387171cf325ff92b34467c27538.jpg";